import { TextOnlyTooltip } from "../TextOnlyTooltip"

type ButtonProps = {
    children : string | React.ReactElement<any, any>,
    classBtn : string,
    onClick : () => void,
    disabled?: boolean,
    titleText?: string
}

export const Button = (props : ButtonProps) => {
    return (
        <TextOnlyTooltip title={props.titleText ? props.titleText : ""} placement="top">
<button disabled={props.disabled === true ? true : false} type="button" className={props.classBtn} onClick={props.onClick}>{props.children}</button>
        </TextOnlyTooltip>
        
    )
}